class BroadcastService {
  private channel: BroadcastChannel | null = null
  private listeners: Map<string, Set<(data: any) => void>> = new Map()

  constructor() {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel('docdot-auth')
      this.channel.onmessage = (event) => {
        const { type, data } = event.data
        const handlers = this.listeners.get(type)
        if (handlers) {
          Array.from(handlers).forEach((handler) => {
            try {
              handler(data)
            } catch (error) {
              console.error(`[BroadcastService] Handler error for type ${type}:`, error)
            }
          })
        }
      }
    } else {
      console.warn('[BroadcastService] BroadcastChannel not supported in this browser')
    }
  }

  subscribe(type: string, handler: (data: any) => void): () => void {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, new Set())
    }
    this.listeners.get(type)!.add(handler)

    return () => {
      const handlers = this.listeners.get(type)
      if (handlers) {
        handlers.delete(handler)
        if (handlers.size === 0) {
          this.listeners.delete(type)
        }
      }
    }
  }

  broadcast(type: string, data?: any): void {
    // BroadcastChannel only works BETWEEN tabs, not in the same tab
    // So we directly call handlers in the same tab
    const handlers = this.listeners.get(type)
    if (handlers && handlers.size > 0) {
      Array.from(handlers).forEach((handler) => {
        try {
          handler(data)
        } catch (error) {
          console.error(`[BroadcastService] Handler error for type ${type}:`, error)
        }
      })
    }
    
    // Also send through BroadcastChannel for other tabs
    if (this.channel) {
      this.channel.postMessage({ type, data })
    }
  }

  close(): void {
    if (this.channel) {
      this.channel.close()
      this.channel = null
    }
    this.listeners.clear()
  }
}

export const broadcastService = new BroadcastService()
